import React from 'react';
import AboutCard from '../components/aboutcard/aboutcard';

const About = () => {
    return ( 
        <>
        <div className="about">

            <AboutCard title="Our History" text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec suscipit auctor dui, sed efficitur ipsum." />
            <AboutCard title="Our Mission" text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec suscipit auctor dui, sed efficitur ipsum." />
            <AboutCard title="Our Team" text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec suscipit auctor dui, sed efficitur ipsum." />
        </div>
        
        </>
     );
}
 
export default About;